import { gql } from "@apollo/client";

export const CRM_SENDING_SCHEDULES = gql`
  query CrmSendingSchedules($where: CrmSendingScheduleWhereInput, $take: Int, $skip: Int) {
    crmSendingSchedules(where: $where, take: $take, skip: $skip) {
      data {
        id
        name
        timezone
        days
        startHour
        endHour
        assignedCampaignIds
      }
      count
    }
  }
`;

const crmSchedules = { CRM_SENDING_SCHEDULES };
export default crmSchedules;
